module.exports = __webpack_public_path__ + "img/m-ren.2be95f4b.jpg";